<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'product/index' }">
                                Produk
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Edit Produk
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Edit Produk
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="form-group">
                                <label class="font-weight-medium">Gambar Produk</label>
                                <input id="image" type="file" class="form-control" v-on:change="preview" placeholder="Choose File" accept="image/*" />
                                <label for="image" class="form-control form-control-sm">
                                    <button type="button" class="btn btn-danger btn-sm font-weight-bold">
                                        Choose File
                                    </button>
                                </label>
                                <img v-bind:src="imagePreview" class="img-fluid mt-2 w-100" />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Judul Produk</label>
                                <input v-model="form.name" class="form-control form-control-sm" placeholder="Judul" required />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Harga Produk</label>
                                <div class="input-group input-group-sm">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Rp</span>
                                    </div>
                                    <input v-model.number="form.price" type="number" class="form-control" placeholder="Harga" required />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Deskripsi Produk</label>
                                <textarea v-model="form.description" class="form-control form-control-sm" placeholder="Deskripsi" spellcheck="false" required></textarea>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Cabang</label>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-check form-check-inline mb-2 mr-4" v-for="(branch, index) in branches" v-bind:key="branch.id">
                                            <div class="custom-control custom-checkbox">
                                                <input v-model="form.branchIDs" type="checkbox" v-bind:value="branch.id" class="custom-control-input" v-bind:id="'input-branch-' + branch.id" />
                                                <label class="custom-control-label" v-bind:for="'input-branch-' + branch.id">{{ branch.name }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-3 text-center">
                                <button type="submit" class="btn btn-danger btn-sm px-5">
                                    Save
                                </button>
                                <router-link v-bind:to="{ name: 'product/index' }" exact class="btn btn-outline-danger btn-sm px-5 ml-3">
                                    Cancel
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "ProductEdit",
        data() {
            return {
                form: {
                    name: '',
                    description: '',
                    price: '',
                    image: '',
                    branchIDs: []
                },
                product: {},
                branches: [],
                imagePreview: ''
            };
        },
        methods: {
            save() {
                var formData = new FormData();
                for (var attribute in this.form) {
                    if (Array.isArray(this.form[attribute])) {
                        for (let i in this.form[attribute]) {
                            formData.append(attribute + '[]', this.form[attribute][i]);
                        }
                    } else {
                        formData.set(attribute, this.form[attribute]);
                    }
                }
                this.axios.post(process.env.API_URL + '/product/update/' + this.product.id, formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'product/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/branch'),
                this.axios.get(process.env.API_URL + '/product/' + this.$route.params.id)
            ]).then(this.axios.spread(function (responseBranch, responseProduct) {
                this.branches = responseBranch.data.data;
                this.product =responseProduct.data.data;
                this.form = Object.assign({}, this.product, {image: '', branchIDs: this.product.branches.map(branch => branch.id)});

                this.imagePreview = this.product.imageUrl;
            }.bind(this)));
        },
        mounted() {
            document.title = 'Edit Product - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/product/Edit.vue